export default function JackpotTickers(props) {
    const renderJackpotTickers = () => {
        if (!props.tickerData) return;

        const tickers = [];
        for (const i in props.tickerData) {
            const ticker = props.tickerData[i];
            let tierValues = "";
            ticker.pots.forEach(pot => {
                tierValues += `${pot.id}: ${pot.current_value.toFixed(4)} ${ticker.currency} | `
            });
            tickers.push(
                <div key={i} className="JackpotTickerItem">
                    <b>{ticker.name} ({ticker.id})</b><br/>
                    {tierValues}
                </div>
            );
        }

        return (
            <div>
                {tickers}
            </div>
        );
    }

    return (
        <div className="JackpotTickerContainer">
            <div className="ContainerLabel">Jackpot Tickers (data refreshed from event stream every 10 seconds)</div>
            {renderJackpotTickers()}
        </div>
    )
}
